import { useState } from 'react';

const TAGS = ['All', 'Culture', 'Fashion', 'History', 'Styling', 'Craft', 'Food'];

const POSTS = [
  {
    id: 1, tag: 'Culture',
    title: 'The Bhadralok Identity: More Than a Word',
    excerpt: 'In Bengali, "Bhadralok" literally means "gentlepeople" — but the cultural weight of that word is immeasurable. We explore the history and modern revival of this identity.',
    author: 'Arnab Chatterjee', date: '12 Jan 2025', readTime: '6 min read',
    img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=70',
  },
  {
    id: 2, tag: 'Fashion',
    title: 'How to Style a Kurta for the Modern Urban Bengali',
    excerpt: 'Gone are the days of kurtas only for Durga Puja. We show you how to make the kurta your everyday uniform — from office to adda to date night.',
    author: 'Priya Bose', date: '5 Feb 2025', readTime: '4 min read',
    img: 'https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?w=600&q=70',
  },
  {
    id: 3, tag: 'History',
    title: 'Muslin to Matka: A History of Bengali Textiles',
    excerpt: 'Bengal\'s textile tradition is one of the richest in the world. From the famous Dhaka Muslin to Shantipur sarees, we trace the threads of history.',
    author: 'Subhadeep Roy', date: '18 Feb 2025', readTime: '8 min read',
    img: 'https://images.unsplash.com/photo-1604176354204-9268737828e4?w=600&q=70',
  },
  {
    id: 4, tag: 'Craft',
    title: 'Meet the Weavers of Shantipur',
    excerpt: 'Behind every Bhadralok garment is a master weaver. We visited the workshops of Shantipur to document their craft, their challenges, and their dreams.',
    author: 'Ritika Sen', date: '3 Mar 2025', readTime: '7 min read',
    img: 'https://images.unsplash.com/photo-1581783898377-1c85bf937427?w=600&q=70',
  },
  {
    id: 5, tag: 'Food',
    title: 'The Perfect Cha Companion: What to Wear for a Kali Puja Adda',
    excerpt: 'The adda is a sacred Bengali institution. Whether it\'s at the para\'s tea stall or your friend\'s rooftop, dressing the part matters. Here\'s our guide.',
    author: 'Arnab Chatterjee', date: '20 Mar 2025', readTime: '3 min read',
    img: 'https://images.unsplash.com/photo-1571091655789-405eb7a3a3a8?w=600&q=70',
  },
  {
    id: 6, tag: 'Styling',
    title: 'Festival Season Lookbook: Puja to New Year',
    excerpt: 'From Durga Puja to Poila Baisakh, every Bengali festival is a fashion moment. Our full lookbook for the 2025 festival season is here.',
    author: 'Priya Bose', date: '4 Apr 2025', readTime: '5 min read',
    img: 'https://images.unsplash.com/photo-1519658742213-f3e6b17e60d3?w=600&q=70',
  },
];

export default function Adda() {
  const [activeTag, setActiveTag] = useState('All');

  const filtered = activeTag === 'All' ? POSTS : POSTS.filter((p) => p.tag === activeTag);
  const featured = filtered[0];
  const rest     = filtered.slice(1);

  return (
    <div className="page-top">
      {/* Hero */}
      <div style={S.hero}>
        <div style={S.heroBg}>ADDA</div>
        <div style={S.heroContent}>
          <p style={{ fontFamily: 'var(--font-script)', fontSize: '22px', color: 'var(--gold)', marginBottom: '8px' }}>আড্ডা</p>
          <h1 style={S.heroTitle}>THE BHADRALOK ADDA</h1>
          <p style={S.heroSub}>Stories, style, history, and cha. This is where we talk about everything that makes us who we are.</p>
        </div>
      </div>

      {/* Tags */}
      <div style={S.tagBar}>
        {TAGS.map((t) => (
          <button key={t}
            style={{ ...S.tagBtn, background: activeTag === t ? 'var(--black)' : '#fff', color: activeTag === t ? '#fff' : 'var(--black)', borderColor: activeTag === t ? 'var(--black)' : 'var(--border)' }}
            onClick={() => setActiveTag(t)}>{t}</button>
        ))}
      </div>

      <div style={S.wrap}>
        {/* Featured Post */}
        {featured && (
          <div style={S.featured}>
            <div style={S.featImg}>
              <img src={featured.img} alt={featured.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <span style={S.tagChip}>{featured.tag}</span>
            </div>
            <div style={S.featContent}>
              <p style={S.metaLine}>By {featured.author} · {featured.date} · {featured.readTime}</p>
              <h2 style={S.featTitle}>{featured.title}</h2>
              <p style={{ fontSize: '14px', color: '#555', lineHeight: 1.8, marginBottom: '20px' }}>{featured.excerpt}</p>
              <button style={S.readBtn}>READ MORE →</button>
            </div>
          </div>
        )}

        {/* Grid Posts */}
        {rest.length > 0 && (
          <div style={S.grid}>
            {rest.map((p) => (
              <div key={p.id} style={S.postCard}>
                <div style={S.postImg}>
                  <img src={p.img} alt={p.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform .4s' }} />
                  <span style={S.tagChip}>{p.tag}</span>
                </div>
                <div style={S.postContent}>
                  <p style={S.metaLine}>{p.author} · {p.date} · {p.readTime}</p>
                  <h3 style={S.postTitle}>{p.title}</h3>
                  <p style={{ fontSize: '12px', color: '#777', lineHeight: 1.75, marginBottom: '14px' }}>{p.excerpt}</p>
                  <button style={S.readBtnSm}>Read More →</button>
                </div>
              </div>
            ))}
          </div>
        )}

        {filtered.length === 0 && (
          <p style={{ textAlign: 'center', color: '#888', padding: '60px' }}>No posts in this category yet. Check back soon!</p>
        )}
      </div>

      {/* Newsletter */}
      <div style={S.newsletter}>
        <div style={{ textAlign: 'center', maxWidth: '520px', margin: '0 auto' }}>
          <p style={{ fontFamily: 'var(--font-script)', fontSize: '20px', color: 'var(--gold)', marginBottom: '8px' }}>Stay Connected</p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '28px', letterSpacing: '2px', color: '#fff', marginBottom: '12px' }}>ADDA IN YOUR INBOX</h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,.5)', marginBottom: '24px', lineHeight: 1.7 }}>Subscribe to get new stories, drop alerts, and exclusive offers — no spam, only cha.</p>
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
            <input style={S.nlInput} placeholder="your@email.com" type="email" />
            <button style={S.nlBtn}>SUBSCRIBE →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const S = {
  hero:         { background: 'var(--black)', padding: '60px 56px 52px', position: 'relative', overflow: 'hidden', borderBottom: '4px solid var(--gold)' },
  heroBg:       { position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)', fontFamily: 'var(--font-display)', fontSize: 'clamp(80px,18vw,240px)', letterSpacing: '-4px', color: 'rgba(255,255,255,.04)', lineHeight: 1, userSelect: 'none' },
  heroContent:  { position: 'relative', zIndex: 1 },
  heroTitle:    { fontFamily: 'var(--font-display)', fontSize: 'clamp(32px,5vw,60px)', letterSpacing: '2px', color: '#fff', lineHeight: 1, marginBottom: '14px' },
  heroSub:      { fontSize: '14px', color: 'rgba(255,255,255,.5)', lineHeight: 1.8, maxWidth: '460px' },
  tagBar:       { display: 'flex', gap: '8px', flexWrap: 'wrap', padding: '20px 56px', background: '#fff', borderBottom: '1px solid var(--border)' },
  tagBtn:       { padding: '7px 16px', border: '1.5px solid', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', transition: 'all .2s' },
  wrap:         { padding: '40px 56px 80px', maxWidth: '1300px', margin: '0 auto' },
  featured:     { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '36px', background: '#fff', border: '1px solid var(--border)', marginBottom: '32px', overflow: 'hidden' },
  featImg:      { height: '420px', position: 'relative', overflow: 'hidden' },
  featContent:  { padding: '40px 32px', display: 'flex', flexDirection: 'column', justifyContent: 'center' },
  tagChip:      { position: 'absolute', top: '16px', left: '16px', background: 'var(--red)', color: '#fff', fontSize: '9px', fontWeight: 700, letterSpacing: '2px', padding: '4px 10px', textTransform: 'uppercase' },
  metaLine:     { fontSize: '11px', color: '#aaa', fontWeight: 600, letterSpacing: '.5px', marginBottom: '10px', textTransform: 'uppercase' },
  featTitle:    { fontFamily: 'var(--font-display)', fontSize: 'clamp(20px,2.5vw,30px)', letterSpacing: '1.5px', lineHeight: 1.2, marginBottom: '14px' },
  readBtn:      { padding: '11px 24px', background: 'var(--black)', color: '#fff', border: 'none', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', cursor: 'pointer', alignSelf: 'flex-start' },
  grid:         { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '20px' },
  postCard:     { background: '#fff', border: '1px solid var(--border)', overflow: 'hidden' },
  postImg:      { height: '200px', position: 'relative', overflow: 'hidden' },
  postContent:  { padding: '20px' },
  postTitle:    { fontFamily: 'var(--font-display)', fontSize: '16px', letterSpacing: '1.5px', lineHeight: 1.3, marginBottom: '10px' },
  readBtnSm:    { background: 'none', border: 'none', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', cursor: 'pointer', color: 'var(--red)', padding: 0 },
  newsletter:   { padding: '72px 56px', background: 'var(--black)', borderTop: '3px solid var(--gold)' },
  nlInput:      { flex: 1, border: '1.5px solid rgba(255,255,255,.2)', background: 'rgba(255,255,255,.06)', padding: '12px 16px', fontFamily: 'var(--font-body)', fontSize: '13px', color: '#fff', outline: 'none', maxWidth: '280px' },
  nlBtn:        { padding: '12px 24px', background: 'var(--red)', color: '#fff', border: 'none', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', cursor: 'pointer', flexShrink: 0 },
};
